import { Github, Linkedin, Code2, Mail } from 'lucide-react';

const LINKS = [
  { icon: Github, href: 'https://github.com/shanmugapriya1203', label: 'GitHub' },
  { icon: Linkedin, href: 'https://www.linkedin.com/in/shanmuga-priya-661935188/', label: 'LinkedIn' },
  { icon: Code2, href: 'https://leetcode.com/_sam1203/', label: 'LeetCode' },
  { icon: Mail, href: 'mailto:priyamuthukumar1203@gmail.com', label: 'Email' },
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-slate-400">
          © {new Date().getFullYear()}{' '}
          <span className="font-semibold bg-gradient-to-r from-violet-600 to-pink-600 bg-clip-text text-transparent">
            Shanmuga Priya
          </span>
        </p>

        <div className="flex items-center gap-3">
          {LINKS.map(({ icon: Icon, href, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="p-2 rounded-full text-slate-400 hover:text-violet-600 hover:bg-violet-50 transition-colors"
            >
              <Icon size={17} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}